import React from 'react';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown';

import styles from './attachmentsStyles.scss';

import Accordion, {
  AccordionContent,
  AccordionTitle
} from '@buyside/components/presentation/Accordion/accordionComponents';

const CollapsiblePanel: React.FC<{
  children?: React.ReactNode;
  dataTag?: string;
  title: JSX.Element | string;
}> = ({ dataTag = '', title, children }): React.ReactElement => (
  <Accordion initialOpen={false} shadowless className={styles.customAccordion}>
    <AccordionTitle expandable expandIcon={faAngleDown} dataTag={dataTag} collapseIcon={faAngleUp}>
      {title}
    </AccordionTitle>
    <AccordionContent>{children}</AccordionContent>
  </Accordion>
);

export default CollapsiblePanel;
